/**
 * 配置编译环境和线上环境之间的切换
 * baseUrl: 域名地址
 * routerMode: 路由模式
 */

//默认渠道号设置
import vconsole from 'vconsole';
let PROXY_URL = {}; // 接口地址

let routerMode = 'hash';

// let businessNo =
//   window.location.href.indexOf("xubei.org") > -1 ? "xubei_h5org" :
//     window.location.href.indexOf("zh.ugpaly.com") > -1 ? "xubei_tfugpaly" :
//       window.location.href.indexOf("zhw.whysjiaoyu.cn") > -1 ? "xubei_whysjiaoyu" :zhw.yunijy.com
//         "xubei_m" //  默认渠道号
// let businessNo = "xubei_m";
// if (window.location.href.indexOf("xubei.org") > -1) {
//   businessNo = "xubei_h5org";
// } else if (window.location.href.indexOf("zh.ugpaly.com") > -1) {
//   businessNo = "xubei_tfugpaly";
// } else if (window.location.href.indexOf("zhw.whysjiaoyu.cn") > -1) {
//   businessNo = "xubei_whysjiaoyu";
// } else if (window.location.href.indexOf("zhw.yunijy.com") > -1) {
//   businessNo = "xubei_mtfyunijy";
// } else if (window.location.href.indexOf("zhw.dreamgardenw.cn") > -1) {
//   businessNo = "xubei_mdreamgardenw";
// } else if (window.location.href.indexOf("m.rfspeed.com") > -1) {
//   businessNo = "xubei_mrfspeed";
// } else if (window.location.href.indexOf("xubei.cc") > -1) {
//   businessNo = "xubei_h5org";
// } else if (window.location.href.indexOf("xb.hzmxwl.com") > -1) {
//   businessNo = "xubei_mhzmxwl";
// } else {
//   businessNo = "xubei_m";
// }

const APP_ID = 'wxe5fdc9f33a443b2c';

if (process.env.API_ENV == 'development' || process.env.API_ENV == 'test') {
	new vconsole();
	PROXY_URL = {
		domain: 'xubei-test.com',
		goodsList: '//good-api.xubei-test.com/goods-api/goods/findGoodsList',
		goods: '//good-api.xubei-test.com/goods-api/goods',
		user: '//user-server.xubei-test.com',
		order: '//cloud-order-api.test.xubei.com',
		pay: '//pay-api.xubei-test.com',
		config: '//api8.xubei-test.com',
		codeport: '//passport-server.xubei-test.com',
		gameList: '//rest-api.xubei.com/appxb/appconfig/rentPage',
		listDetails: '//list.xubei-test.com/free_play',
		userApi: '//user-api.xubei-test.com/user-api',
		commonServer: '//common-server.xubei-test.com',
		zzshq: 'http://api.zzshq.xubei-test.com',
		tracking: '//tracking.xubei-test.com'
	};
} else {
	//线上环境
	PROXY_URL = {
		domain: 'xubei.com',
		goodsList: '//good-solr.xubei.com/goods/findGoodsLists',
		goods: '//good-api.xubei.com/goods-api/goods',
		user: '//user-server.xubei.com',
		order: '//order-api.xubei.com',
		pay: '//pay-api.xubei.com',
		config: '//api8.xubei.com',
		codeport: '//passport-server.xubei.com',
		gameList: '//rest-api.xubei.com/appxb/appconfig/rentPage',
		listDetails: '//list.xubei.com/free_play',
		userApi: '//user-api.xubei.com/user-api',
		commonServer: '//common-server.xubei.com',
		zzshq: 'http://api.zzshq.xubei.com',
		tracking: '//tracking.xubei.com'
	};

	//测试环境
	// PROXY_URL = {
	//   goodsList: '//good-api.xubei-test.com/goods-api/goods/findGoodsList',
	//   goods: '//good-api.xubei-test.com/goods-api/goods',
	//   user: '//user-server.xubei-test.com',
	//   order: '//cloud-order-api.test.xubei.com',
	//   pay: '//pay-api.xubei-test.com',
	//   config: '//api8.xubei-test.com',
	//   codeport:'//passport-server.xubei-test.com',
	//   gameList:'//rest-api.xubei.com/appxb/appconfig/rentPage',
	//   listDetails:'//list.xubei-test.com/free_play',
	//   userApi:'//user-api.xubei-test.com/user-api'
	// };

	// 线上强制跳转https
	// var targetProtocol = "https:";
	// if (window.location.protocol != targetProtocol)
	// window.location.href = targetProtocol +
	// window.location.href.substring(window.location.protocol.length);
}

export { routerMode, PROXY_URL, APP_ID };



// WEBPACK FOOTER //
// ./src/config/env.js